module.exports = __webpack_public_path__ + "img/inspect_person.c8173aee.png";